import React, { useState } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {
  Container,
  Stack,
  Grid,
  Typography,
  Button,
  Modal,
  Box,
  TextField,
} from "@mui/material";
import { answerQuery } from "../../../apis";

const style = {
  position: "absolute",
  top: "25%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "white",
  p: 4,
};

const SelectedHRManager = ({ currentQueryDetails, handleFetchNewData }) => {
  const [modalError, setModalError] = useState(false);
  const [open, setOpen] = useState(false);
  const [answer, setAnswer] = useState("");

  const handleClose = () => {
    setOpen(false);
    setAnswer("");
    setModalError(false);
  };

  const answerSubmitHandler = async () => {
    if (answer == "") {
      setModalError(true);
      return;
    } else {
      let data = await answerQuery({
        email: currentQueryDetails.email,
        id: currentQueryDetails._id,
        answer: answer,
        title: currentQueryDetails.title,
      });
      if (data) {
        setOpen(false);
        handleFetchNewData();
      }
      setModalError(false);
    }
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack spacing={2}>
            {modalError ? (
              <Stack>
                <Typography style={{ color: "red" }}>
                  Please enter all of the required fields.
                </Typography>
              </Stack>
            ) : (
              <></>
            )}

            <Stack>
              <Typography>Answer</Typography>
              <TextField
                multiline
                rows={3}
                size="small"
                id="outlined-basic"
                placeholder="Enter your answer here"
                variant="outlined"
                className="w-100 mt-5"
                onChange={(e) => setAnswer(e.target.value)}
              />
            </Stack>

            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button
                variant="outlined"
                className="default-color default-border"
                style={{ textTransform: "capitalize" }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="primary-button"
                style={{ textTransform: "capitalize" }}
                onClick={answerSubmitHandler}
              >
                Submit
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <Container style={{ background: "#FAFBFE", height: "100vh" }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack>
            <h2>Query Details</h2>
          </Stack>
        </Stack>
        <Grid container>
          <Grid item sm={2}>
            <AccountCircleIcon
              style={{ height: "80px", width: "80px", color: "#EEEBEF" }}
            />
          </Grid>
          <Grid item sm={10}>
            <Stack direction="row" justifyContent="space-between">
              <Stack>
                <Stack spacing={1} className="mb-5">
                  <Typography
                    style={{ fontWeight: "bold", textTransform: "capitalize" }}
                  >
                    {currentQueryDetails.title}
                  </Typography>
                  <Typography className="ammanat-darker-gray">
                    {currentQueryDetails.email}
                  </Typography>
                  {/* <CheckCircleIcon
                style={{ height: "15px", width: "15px", color: "#FA8319" }}
              /> */}
                </Stack>
              </Stack>

              <div
                style={{ background: "white", padding: "20px", width: "200px" }}
              >
                <Stack spacing={2} alignItems="center">
                  <Button
                    variant="contained"
                    className="primary-button"
                    style={{
                      textTransform: "capitalize",
                      width: "168px",
                    }}
                    onClick={() => setOpen(true)}
                  >
                    Answer
                  </Button>
                </Stack>
              </div>
            </Stack>

            <Stack>
              <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                Description
              </Typography>
              <Typography variant="body1" className="ammanat-darker-gray">
                {currentQueryDetails.description}
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default SelectedHRManager;
